import { serverURL } from '../constants'
import { useEffect, useState, useRef } from 'react'
import '../styles/Login.css'

function Login() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showBackgroundPlayer, setShowBackgroundPlayer] = useState(false);
  const backgroundRef = useRef(null);

  useEffect(() => {
    // Trigger animation after a short delay
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    // Lazy load the background player after a delay to prevent rate limiting
    const backgroundTimer = setTimeout(() => {
      setShowBackgroundPlayer(true);
    }, 2000); // 2 second delay to prevent immediate loading

    return () => {
      clearTimeout(timer);
      clearTimeout(backgroundTimer);
    };
  }, []);

  const handleLoginClick = () => {
    setIsLoading(true);
    // The redirect will happen automatically via the href
  };

  return (
    <div className="relative min-h-screen flex flex-col justify-center items-center">
      {/* Background Twitch Stream - Lazy Loaded */}
      <div className="fixed inset-0 z-0">
        {showBackgroundPlayer ? (
          <iframe
            ref={backgroundRef}
            title="Background Twitch Stream - Live gaming content"
            src={`https://player.twitch.tv/?channel=av_3v3&parent=${window.location.hostname}&autoplay=true&muted=true&controls=false`}
            width="100%"
            height="100%"
            frameBorder="0"
            scrolling="no"
            allow="autoplay; fullscreen; encrypted-media"
            allowFullScreen
            className="w-full h-full"
            style={{ pointerEvents: 'none' }}
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-pulse">
            <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          </div>
        )}
        {/* Dark overlay to make content more readable */}
        <div className="absolute inset-0 bg-black bg-opacity-70"></div>
      </div>
      
      {/* Skip to main content for accessibility */}
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-white text-black px-4 py-2 rounded z-50">
        Skip to main content
      </a>
      
      {/* Login content with higher z-index */}
      <div id="main-content" className="relative z-10 text-center px-6 max-w-md mx-auto">
        <div className={`transition-all duration-1000 ease-out ${
          isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
        }`}>
          <div className="mb-8">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 drop-shadow-2xl">
              Clip Digest
            </h1>
            <p className="text-lg md:text-xl text-gray-300 drop-shadow-lg">
              Discover the best moments from your favorite streamers
            </p>
          </div>

          <a 
            href={`${serverURL}/auth/link`} 
            rel="noreferrer" 
            className='inline-block'
            onClick={handleLoginClick}
            aria-label="Login with Twitch account"
          >
            <button 
              className={`rounded-full bg-twitch-purple hover:bg-purple-600 text-2xl px-8 py-4 text-white font-semibold transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-purple-300 focus:ring-opacity-50 ${
                isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
              } ${isLoading ? 'opacity-75 cursor-not-allowed' : ''}`} 
              style={{ 
                transitionDelay: '300ms', 
                boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
                textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
              }}
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white mr-3"></div>
                  Connecting...
                </div>
              ) : (
                <div className="flex items-center justify-center">
                  <svg className="w-6 h-6 mr-3" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"/>
                  </svg>
                  Login with Twitch
                </div>
              )}
            </button>
          </a>
        </div>
      </div>
    </div>
  )
}

export default Login